import { UserActions } from '../actions';

export const user = (state = null, actions) => {
  switch (actions.type) {
    case UserActions.PROFILE_RECEIVED:
      return Object.assign({}, state, { profile: actions.profile });
    case UserActions.COMPANY_RECEIVED:
      return Object.assign({}, state, { company: actions.company });
    default:
      return state;
  }
}

export default user;


// WEBPACK FOOTER //
// ./src/reducers/user.js